/**
 * Pdf portal
 * Portal to generate PDF and handle authentication.
 *
 * OpenAPI spec version: 1.0.32
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { EvaluationCategoryRule } from './evaluationCategoryRule';
import { GenderEnum } from './genderEnum';
import { NullEnum } from './nullEnum';
import { RuleOpenApi } from './ruleOpenApi';

/**
 * Base class serializer for all OpenAPI serializers.  It only implements create/update method without any logic to prevent \"abstract\" warning by pylint.
 */
export interface EvaluationRangeOpenApi { 
    id: number;
    evaluationType: string;
    testRule: RuleOpenApi;
    categoryRules: Array<EvaluationCategoryRule>;
    generalRule: RuleOpenApi;
    _default?: boolean;
    ageFrom?: number;
    ageTo?: number;
    gender?: GenderEnum | NullEnum;
}